import { Theme } from "../../../../components/constants";

export default {
    header: {
        display: "flex",
        alignItems: "center",
        columnGap: "8px"
    },

    statusHeading: {
        fontWeight: "600",
        fontSize: "20px",
        lineHeight: "24px",
        margin: "0 0 5px 0"
    },

    notification: {
        display: "flex",
        columnGap: "7px",
        fontSize: "16px",
        marginTop: "20px",
        alignItems: "baseline"
    },

    count: {
        fontSize: "20px"
    },

    action: {
        color: Theme.PRIMARY,
        fontWeight: "700",
        fontSize: "14px",
        cursor: "pointer",
        marginLeft: "20px"
    },
}